export default function Loader() {
  return (
    <div style={{ textAlign: "center", padding: "40px" }}>
      <p>Chargement...</p>
    </div>
  );
}